import React from 'react'

export default function SectionTitle({ text }) {
  return <h2 className="f-30 f-w-700 text-center mb-3"> ~ Section {text} ~ </h2>
}
